// extracted by mini-css-extract-plugin
export default {"root":"IconChip_root__6hMAa","size-small":"IconChip_size-small__oa5YI","size-medium":"IconChip_size-medium__Dx4u5","size-big":"IconChip_size-big__GD5Lv"};